// extracted by mini-css-extract-plugin
module.exports = {"listPb":"CataloghiSection_listPb__ndHe2","list":"CataloghiSection_list__V3F3A","rotation":"CataloghiSection_rotation__7UTAM"};